import React from 'react'

export default function Footer() {
    return (
        <footer className="app-footer">
            <div className="footer-content">
                <p className="footer-text">
                    © {new Date().getFullYear()} MYPacôme. Tous droits réservés.
                </p>
            </div>
        </footer>
    )
}
